export default __webpack_public_path__ + "static/media/supportkit.c42e7e52.svg";